// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"14":"tv","137":"screens","177":"home","278":"screen-1","328":"admin","934":"screen-2"}[chunkId] + "-legacy." + {"14":"f0836c3f","137":"47963730","177":"aced25e4","278":"93b64cfa","328":"605bda41","934":"42eb9dfe"}[chunkId] + ".js";
};